import {useCallback} from "react";
import {useFormContext} from "react-hook-form";

import {calculateToDateTime} from "../lib";

const PRESETS_DURATION = [4, 8, 12];

interface UsePresetsDurationProps {
  isTemplate?: boolean;
}

export default function usePresetsDuration({isTemplate}: UsePresetsDurationProps) {
  const {setValue, getValues} = useFormContext();

  const handleDurationPreset = useCallback(
    (hours: number) => {
      const {from_date, from_time} = getValues() as {
        from_date: Date | undefined;
        from_time: string | undefined;
      };

      if ((!isTemplate && !from_date) || !from_time) return;

      const date = isTemplate || !from_date ? undefined : from_date.toISOString().slice(0, 10);
      const {endDate, endTime} = calculateToDateTime(date, from_time, hours);

      !isTemplate && setValue("to_date", endDate);
      setValue("to_time", endTime);
    },
    [setValue, getValues],
  );

  return {
    presetsDuration: PRESETS_DURATION,
    onSelectPreset: handleDurationPreset,
  };
}
